import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { IParallaxScrollConfig } from 'ngx-parallax-scroll';


@Component({
  selector: 'app-gmix-world',
  templateUrl: './gmix-world.component.html',
  styleUrls: ['./gmix-world.component.scss']
})
export class GmixWorldComponent implements OnInit {

  public itsMobile = false;
  public tablet = false;
  @Output() numberEmiter = new EventEmitter<string>();

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };

  constructor() { }

  ngOnInit(): void {
    if (this.verifyMobile()) {
      this.itsMobile = true;
    }

    if(window.innerWidth < 850){
      this.tablet = true;
    }else{
      this.tablet = false;
    }
  }

  verifyMobile(): any {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];


    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  sendVideo(): void {
    this.numberEmiter.emit("9");
  }

}
